// This component renders the Index primary shard count skew table
import { useCollection } from '@amzn/awsui-collection-hooks';
import {
  Button,
  ExpandableSection,
  Header,
  Pagination,
  SpaceBetween,
  Table,
  TextFilter,
} from '@amzn/awsui-components-react';
import React, { useState } from 'react';
import { AnyObject } from '../../../../../models/types';
import {
  DEFAULT_PREFERENCES,
  indexPrimaryShardCountColumns,
  PAGE_SIZE_OPTIONS,
  VISIBLE_CONTENT_OPTIONS,
} from '../columns';
import {
  EmptyState,
  getFilterCounterText,
  Preferences,
} from './../../../../../utils/tablePreferences';

interface IndexPrimaryShardCountSkewInfoProps {
  indexPrimaryShardCountSkew: Array<Array<object>>;
  dropdownsInfo: Array<Array<Array<boolean>>>;
  diNumber: number;
  setDropdownsInfo: (state: Array<Array<Array<boolean>>>) => void;
  isLoading: boolean;
}

const IndexPrimaryShardCountSkewInfo = (props: IndexPrimaryShardCountSkewInfoProps) => {

  const [preferences, setPreferences] = useState(DEFAULT_PREFERENCES);

  // Create an object to hold the type of each index
  const indexTypeMap: { [indexName: string]: string } = {};

  // Process all index types at once
  const allIndexTypeData = props.indexPrimaryShardCountSkew[props.diNumber].flatMap(
    indexType => {
      return indexType['valuesForTable'].map(item => {
        indexTypeMap[item['indexName']] = indexType['type'];
        return item;
      });
    }
  );

  const {
    items,
    actions,
    filteredItemsCount,
    collectionProps,
    filterProps,
    paginationProps,
  } = useCollection(
    props.indexPrimaryShardCountSkew[props.diNumber].length > 0
      ? allIndexTypeData
      : [],
    {
      filtering: {
        empty: (
          <EmptyState
            title="No Skew"
            subtitle="No issues to display."
            action={<span></span>}
          />
        ),
        noMatch: (
          <EmptyState
            title="No matches"
            subtitle="We can’t find a match."
            action={
              <Button onClick={() => actions.setFiltering('')}>
                Clear filter
              </Button>
            }
          />
        ),
      },
      pagination: { pageSize: preferences.pageSize },
      sorting: {},
    }
  );
  return (
    <React.Fragment>
      {props.indexPrimaryShardCountSkew[props.diNumber].length > 0 && (
        <SpaceBetween direction="vertical" size="xs">
          {props.indexPrimaryShardCountSkew[props.diNumber].map(
            (indexType: AnyObject, j) => (
              // <Container
              //   disableContentPaddings
              //   header={<Header variant="h2">Index primary shard count skew</Header>}
              // >
              <ExpandableSection
                header={<Header variant="h2">Index primary shard count skew</Header>}
              >
                {/* <Header variant="h2">Index primary shard count skew</Header> */}
                <Table
                  header={
                    <Header variant="h3">
                      {
                        <span>
                          {indexType.type.charAt(0).toUpperCase() +
                            indexType.type.slice(1)}{' '}
                          {indexType.desc}
                        </span>
                      }
                    </Header>
                  }
                  {...collectionProps}
                  columnDefinitions={indexPrimaryShardCountColumns}
                  stickyHeader={true}
                  wrapLines={preferences.wraplines}
                  loading={props.isLoading}
                  loadingText={
                    props.isLoading
                      ? 'Loading Security Groups'
                      : 'No Security Groups found'
                  }
                  visibleColumns={preferences.visibleContent}
                  items={items.filter(item => indexTypeMap[item['indexName']] === indexType['type'])}
                  pagination={
                    <Pagination
                      {...paginationProps}
                      ariaLabels={{
                        nextPageLabel: 'Next page',
                        previousPageLabel: 'Previous page',
                        pageLabel: (pageNumber) =>
                          `Page ${pageNumber} of all pages`,
                      }}
                    />
                  }
                  filter={
                    <TextFilter
                      {...filterProps}
                      countText={getFilterCounterText(filteredItemsCount)}
                      filteringAriaLabel="Filter instances"
                    />
                  }
                  preferences={
                    <Preferences
                      preferences={preferences}
                      setPreferences={setPreferences}
                      disabled={false}
                      pageSizeOptions={PAGE_SIZE_OPTIONS}
                      visibleContentOptions={VISIBLE_CONTENT_OPTIONS}
                    />
                  }
                />
              </ExpandableSection>
            )
          )}
        </SpaceBetween>
      )}
    </React.Fragment>
  );
};

export { IndexPrimaryShardCountSkewInfo };
